module.exports = __webpack_public_path__ + "static/media/Inter-ThinItalic.a9780071.woff2";